import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FileData, FileId } from 'src/app/shared/models/candidate';

@Injectable({
  providedIn: 'root',
})
export class SearchCandidateService {
  id = parseInt(localStorage.getItem('fresherCompHiringTypeId'));

  scheduleStatsUrl: string = environment.dashboardUrl;
  candidateSearchUrl: string = environment.candidateSearchUrl;
  elasticUrl: string = environment.elasticUrl;
  schedulerDashboardUrl: string = environment.schedulerDashboardUrl;
  activityUrl: string = environment.activityUrl;
  mongoApiUrl: string = environment.mongoApiUrl;
  recruiterGenUrl: string = environment.recruiterGenUrl;
  recruiterUrl: string = environment.recruiterUrl;
  CreateCandidateUrl: string = environment.createCandidateUrl;
  careerUrl: string = environment.careerUrl;
  resumePushUrl: string = environment.resumePushUrl;
  searchKeyWord: BehaviorSubject<string> = new BehaviorSubject<string>('');
  activeAdvanceSearch: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  recruiterDashboardUrl: string = environment.recruiterdashboardUrl;
  private subStatSubject = new BehaviorSubject<any>('');
  subStatSubject$ = this.subStatSubject.asObservable();

  readonly get_skill_details = `${this.recruiterGenUrl}getSkillDetails`;
  searchVariable: any;

  constructor(private http: HttpClient) {}

  getAllInstitute() {
    return this.http.get<any>(`${this.careerUrl}getAllInstitutes`);
  }
  getAllCompany() {
    return this.http.get<any>(`${this.CreateCandidateUrl}getAllEmploymentOrganizations`);
  }
  getCitiesVenue(initial) {
    return this.http.get<any>(`${this.recruiterUrl}Events/getcityDetails` + `/${initial}`);
  }

  // to get skills elastic search
  getSkillDetails(skillKeyword) {
    const companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
    console.log('company hiring type---', companyHiringType);
    return this.http.get(`${this.recruiterGenUrl}getSkillDetails` + `/${companyHiringType}/${skillKeyword}`);
  }
  setActiveAdvanceSearch(value) {
    this.activeAdvanceSearch.next(value);
  }
  getActiveAdvanceSearch() {
    return this.activeAdvanceSearch.asObservable();
  }

  advSearchCandidate(searchBody) {
    //console.log("!!!SEARCHBODY",searchBody);

    return this.http.post<any>(`${this.elasticUrl}elasticCandidate/searchCandidatesFilter`, searchBody);
  }

  setSchedulerUrl(envJson) {
    // console.log("!!!env",envJson);

    this.scheduleStatsUrl = envJson['DashboardUrl'];
    this.schedulerDashboardUrl = envJson['SchedulerDashboardUrl'];
    this.activityUrl = envJson['ActivityUrl'];
    this.mongoApiUrl = envJson['MongoApiUrl'];
    this.recruiterUrl = envJson['RecruiterUrl'];
    this.recruiterGenUrl = envJson['RecruiterGenUrl'];
    this.CreateCandidateUrl = envJson['CreateCandidateUrl'];
    this.careerUrl = envJson['CareerUrl'];
    this.resumePushUrl = envJson['ResumePushUrl'];
    this.candidateSearchUrl = envJson['CandidateSearchUrl'];
    this.elasticUrl = envJson['ElasticUrl'];
    this.recruiterDashboardUrl = envJson['RecruiterdashboardUrl'];
  }

  searchCandidate(searchBody) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    // return this.http.get<any>('assets/json/searchCandidate.json', options)
    return this.http.post<any>(this.elasticUrl+'elasticCandidate/searchCandidatesCopy',searchBody, options)
    // return this.http.post<any>(this.candidateSearchUrl + 'searchCandidates',searchBody, options);
  }

  getCandidateListByIds(applicationIds): Observable<any> {
    return this.http.post<any>(this.schedulerDashboardUrl + 'candidate/getAllCandidates', applicationIds);
  }

  getCandidateBasicDetails(applicationId: any, candidateId: any): Observable<any> {
    return this.http.get<any>(
      this.schedulerDashboardUrl +
        'candidate/getBasicCandidateDetails?candidateId=' +
        candidateId +
        '&applicationId=' +
        applicationId,
    );
  }
  syncApi(applicationIds, hiringTypeId): Observable<any> {
    const data = {
      applicationIds: applicationIds,
      hiringTypeId: hiringTypeId,
    };
    return this.http.post<any>(`${this.resumePushUrl}updateIWPDetailsInput`, data);
  }

  getProcessActivities(roleCode): Observable<any> {
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    // if (roleCode == 'Offer DEO') {
    //   roleCode = 'Offer_DEO';
    // }
    const body = {
      roleCode: roleCode,
      companyHiringTypeId: this.id ? this.id : parseInt(localStorage.getItem('fresherCompHiringTypeId')),
    };

    return this.http.post<any>(this.activityUrl + 'activity/getRolesActivitiesProcesses', body, options);
  }

  getCHTById(): Observable<any> {
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    const id = [parseInt(localStorage.getItem('fresherCompHiringTypeId'))];
    return this.http.post<any>(`${this.scheduleStatsUrl}DashboardServices/getCompanyHiringTypesByIds`, id, options);
  }
  getApplicationIDs(candidateID) {
    return this.http.get<any[]>(
      this.schedulerDashboardUrl + 'candidate/getCandidateApplications?candidateId=' + candidateID,
    );
  }
  setSearchKeyword(value) {
    // this.searchKeyWord.next(value)
    this.searchVariable = value;
  }
  getSearchKeyword() {
    // return this.searchKeyWord.asObservable()
    return this.searchVariable;
  }
  getFileId(data): Observable<FileData[]> {
    return this.http.get<FileData[]>(
      this.mongoApiUrl + 'getFileId/' + data.objectId + '/' + data.objectType + '/' + data.attachmentId,
    );
  }
  getResume(id): Observable<FileId[]> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<FileId[]>(this.mongoApiUrl + "downloadFileNew", { params: params })
  }
  dupCheck(id) {
    return this.http.get<any[]>(this.recruiterDashboardUrl + 'getDuplicatesByCandidateId/' + id);
  }
  updateSubstatus(data: any) {
    this.subStatSubject.next(data);
  }
  getSubstatus() {
    return this.subStatSubject.getValue();
  }
}
